export enum ViteAppMode {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export enum DeployEnv {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

/**
 * ## VITE APP 빌드 동작 모드
 * 동작 모드에 따라 다른 env 파일을 로딩 `.env.{AppEnv}`
 * - development
 * - staging
 * - production
 *  @summary `vite build --mode {AppEnv}` | `vite dev --mode {AppEnv}`
 *  @enum ViteAppMode
 *  @link https://vite.dev/guide/env-and-mode.html#env-files
 */
export const APP_MODE = (import.meta.env.MODE as ViteAppMode) || ViteAppMode.PRODUCTION;

/**
 * ## 배포 환경 설정
 * `APP_MODE` 와 대부분의 경우 동일하지만, `local` 이나 테스트 환경을 구성할 경우 다르게 설정할 수 있습니다.
 * - local
 * - development
 * - staging
 * - production
 * @summary
 *  ```bash
 *  # .env
 *  VITE_DEPLOY_ENV={DeployEnv}
 *  ```
 * @enum DeployEnv
 */
export const DEPLOY_ENV = (import.meta.env.VITE_DEPLOY_ENV as DeployEnv) || DeployEnv.PRODUCTION;

/** 배포 버전 (설정 화면 표기 등) — `.env` VITE_DEPLOY_VERSION */
export const DEPLOY_VERSION = (import.meta.env.VITE_DEPLOY_VERSION as string) || '0.0.0';
